import { render, staticRenderFns } from "./CMSConfig.vue?vue&type=template&id=f50aef00&scoped=true&"
import script from "./CMSConfig.vue?vue&type=script&lang=js&"
export * from "./CMSConfig.vue?vue&type=script&lang=js&"
import style0 from "./CMSConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CMSConfig.vue?vue&type=style&index=1&id=f50aef00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50aef00",
  null
  
)

export default component.exports